/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import "../adminCard.css";
import { Modal } from "react-bootstrap";

const ChefMenuCountPopup = ({ data, show, selectedChefData, handleDismiss }) => {

  return (
    <Modal size="lg" show={show} backdrop="static">
      <Modal.Header>
        <Modal.Title>Menu Counts of {selectedChefData.userName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Breakfast - {data.Breakfast} </strong>{" "}
        </p>
        <p>
          <strong>Lunch - {data.Lunch} </strong>
        </p>
        <p>
          <strong>Snacks- {data.Snacks} </strong>{" "}
        </p>
        <p>
          <strong>Dinner {data.Dinner} </strong>{" "}
        </p>
        <p>
          <strong>Ready to Serve - {data["Ready to Serve"]} </strong>{" "}
        </p>
        <p>
          <strong>Festive Delights - {data["Festive Delights"]} </strong>{" "}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          data-dismiss="modal"
          onClick={() => handleDismiss()}
        >
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ChefMenuCountPopup;
